<template>
  <div class="best-value-box o-flex o-flex--center">
    <div>
      <p>{{ packageName(bestValue) }}</p>
      <span
        >{{ bestValue.currency.toUpperCase() }}
        {{ bestValue.price.toFixed(2) }}</span
      >
    </div>
    <button
      type="button"
      class="button button--primary"
      :disabled="packageActionDisabled"
      @click="packageClickHandler(best)"
    >
      {{ $t("credits.continue") }}
    </button>
  </div>

  <div class="price">
    <div class="price__box-modal" v-if="paymentModal">
      <div
        @click="packageClickHandler(p)"
        style="cursor: pointer"
        v-for="p in packages"
        :key="p.id"
        class="price__item price__item--modal o-flex o-flex--center o-flex--justify"
        :class="{ 'is-active': p.id === best?.id }"
      >
        <div class="u-text-left">
          <h3>
            <svg
              v-if="p.id === best?.id"
              class="best-value"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="16"
            >
              <path
                data-name="Icon awesome-crown"
                d="M16.5 14h-13a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm2-10A1.5 1.5 0 0 0 17 5.5a1.47 1.47 0 0 0 .137.619l-2.262 1.356a1 1 0 0 1-1.381-.363l-2.547-4.456a1.5 1.5 0 1 0-1.894 0L6.506 7.112a1 1 0 0 1-1.381.362L2.866 6.119A1.5 1.5 0 1 0 1.5 7a1.532 1.532 0 0 0 .241-.025L4 13h12l2.259-6.025A1.532 1.532 0 0 0 18.5 7a1.5 1.5 0 1 0 0-3Z"
                fill="#c59264"
              /></svg
            >{{ creditCount(p) }}
          </h3>
          <h4 class="mb0">
            {{ p.currency.toUpperCase() }} {{ p.price.toFixed(2) }}
          </h4>
        </div>
        <button :disabled="packageActionDisabled" class="button button--primary">
          {{ ucFirst($t("credits.buy_credits")) }}
        </button>
      </div>
    </div>
    <div class="price__boxes-wrapper" v-else>
      <a class="scroll-trigger scroll-left" v-if="mobile" @click="slideLeft">
        <svg width="10" viewBox="0 0 14 14">
          <path
            fill="#fff"
            d="m7.71.3 6.03 6.03a1 1 0 0 1-.03 1.38l-6 6a1 1 0 0 1-1.42 0 1 1 0 0 1 0-1.41L10.6 8H1a1 1 0 0 1-1-1 1 1 0 0 1 1-1h9.6L6.3 1.7A1 1 0 0 1 6.3.3 1 1 0 0 1 7 0a1 1 0 0 1 .71.3Z"
          />
        </svg>
      </a>
      <div
        class="price__boxes"
        ref="priceBoxes"
        @touchstart="onTouchStart"
        @touchend="onTouchEnd"
        :class="{ 'prices__boxes-mobile': mobile }"
      >
        <div
          @click="
            packageClickHandler(p);
            currentIndex = i;
            slideToIndex(i);
          "
          style="cursor: pointer"
          v-for="(p, i) in packages"
          :key="p.id"
          class="price__item"
          :class="{ 'is-active': p.id === best?.id }"
        >
          <div class="price__item-row">
            <h2 class="heading">
              {{ packageName(p) }}
            </h2>
            <p class="unlock-chats">
              {{ $t("credits.unlock_chats", { chats: unlockableChats(p.credits) }) }}
            </p>
            <div class="price-box">
              {{ packageDescription(p) }}
            </div>
          </div>
          <div class="save-box" v-if="packageSavePercent(p)">
            {{ $t("credits.save_percent", { percent: packageSavePercent(p) }) }}
          </div>
          <div class="price__item-row credits-euro">
            <div class="divider"></div>
            <h3 class="mb-">{{ creditCount(p) }}</h3>

            <p class="u-text-left euro-credit">
              {{ pricePerCreditText(p) }}
            </p>
          </div>

          <div class="price__item-row">
            <h4 class="total">
              {{ p.currency.toUpperCase() }} {{ p.price.toFixed(2) }}
            </h4>
            <button
              :disabled="packageActionDisabled || !confirmed"
              class="button button--primary"
            >
              {{ continueWithCredits(p) }}
            </button>
          </div>
        </div>
      </div>
      <a class="scroll-trigger scroll-right" v-if="mobile" @click="slideRight">
        <svg width="10" viewBox="0 0 14 14">
          <path
            fill="#fff"
            d="m7.71.3 6.03 6.03a1 1 0 0 1-.03 1.38l-6 6a1 1 0 0 1-1.42 0 1 1 0 0 1 0-1.41L10.6 8H1a1 1 0 0 1-1-1 1 1 0 0 1 1-1h9.6L6.3 1.7A1 1 0 0 1 6.3.3 1 1 0 0 1 7 0a1 1 0 0 1 .71.3Z"
          />
        </svg>
      </a>
      <div
        class="slider-dots u-text-center"
        v-if="mobile && packages.length > 1"
      >
        <span
          v-for="(p, i) in packages"
          :key="i"
          class="dot"
          :class="{ active: i === currentIndex }"
          @click="
            currentIndex = i;
            slideToIndex(i);
          "
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import ThemeMixin from "@/mixins/ThemeMixin";
import { ucFirst } from "@/utilities/general";
import { mapState } from "vuex";

export default {
  name: "DefaultPromotion",
  mixins: [ThemeMixin],
  emits: ["selected"],
  props: {
    packages: {
      type: Array,
    },
    working: {
      type: Boolean,
      required: true,
    },
    promotion: {
      type: Object,
      required: true,
    },
    paymentModal: {
      type: Boolean,
      default: false,
    },
    confirmed: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      currentIndex: 1,
      touchStartX: 0,
      touchEndX: 0,
      packageClickPending: false,
    };
  },
  computed: {
    ...mapState({
      mobile: (state) => state.application.mobile,
    }),
    bestValue() {
      return (
        this.packages.find((pkg) =>
          ["popular_choice", "best_value"].includes(this.packageType(pkg))
        ) ||
        this.packages[1] ||
        this.packages[0]
      );
    },
    best() {
      return (
        this.packages.find((pkg) =>
          this.packageType(pkg) === "popular_choice"
        ) ||
        this.packages.find((pkg) => this.packageType(pkg) === "best_value") ||
        this.packages[1]
      );
    },
    elit() {
      return (
        this.packages.find((pkg) => ["elite", "premium"].includes(this.packageType(pkg)))
      );
    },
    packageActionDisabled() {
      return this.working || this.packageClickPending;
    },
  },
  methods: {
    ucFirst,
    packageClickHandler(p) {
      if (this.packageActionDisabled || !p) return;

      this.packageClickPending = true;
      this.processingModal = true;

      setTimeout(() => {
        this.processingModal = false;

        this.$emit("selected", p);
        this.$nextTick(() => {
          this.packageClickPending = false;
        });
      }, 2000);
    },
    packageDescription(p) {
      const packageType = this.packageType(p);

      if (["popular_choice", "best_value"].includes(packageType)) {
        return this.$t("credits.most_popular_choice");
      }

      if (["premium", "elite"].includes(packageType)) {
        return this.$t("credits.great_for_getting_started");
      }

      if (packageType === "introductory") {
        return this.$t("credits.try_the_experience");
      }

      return "";
    },
    packageType(p) {
      if (!p) return "";

      const packageName = p.name.toLowerCase();

      if ([3, 41].includes(p.id) || packageName.includes("introductory")) return "introductory";
      if ([2, 42].includes(p.id) || packageName.includes("popular")) return "popular_choice";
      if (packageName.includes("best")) return "best_value";
      if ([1].includes(p.id) || packageName.includes("elite")) return "elite";
      if ([43].includes(p.id) || packageName.includes("premium")) return "premium";

      return "";
    },
    packageName(p) {
      const keys = {
        introductory: "credits.package_introductory",
        popular_choice: "credits.package_popular_choice",
        best_value: "credits.package_popular_choice",
        elite: "credits.package_elite",
        premium: "credits.package_premium",
      };
      const key = keys[this.packageType(p)];

      return key ? this.$t(key) : p?.name;
    },
    creditCount(p) {
      return this.$t("credits.credit_count", { count: p.credits });
    },
    continueWithCredits(p) {
      return this.$t("credits.continue_with_credits", { count: p.credits });
    },

    packageSavePercent(p) {
      if (this.best && p.id === this.best.id) {
        return 35;
      }

      if (this.elit && p.id === this.elit.id) {
        return 20;
      }

      return 0;
    },
    pricePerCredit(p) {
      const currency =
        p.currency.toUpperCase() === "EUR"
          ? "€"
          : `${p.currency.toUpperCase()} `;

      return `${currency}${Number(p.price / p.credits).toFixed(2)}`;
    },
    pricePerCreditText(p) {
      return this.$t("credits.price_per_credit", { price: this.pricePerCredit(p) });
    },
    unlockableChats(credits) {
      return Math.floor(
        parseInt(credits) /
          (parseInt(process.env.VUE_APP_UNLOCK_CONVERSATION) || 10)
      );
    },
    unlockableGalleries(credits) {
      return Math.round(
        parseInt(credits) / process.env.VUE_APP_UNLOCK_CONVERSATION
      );
    },
    slideToIndex(index) {
      const container = this.$refs.priceBoxes;

      if (!container) return;

      const items = container.querySelectorAll(".price__item");
      const item = items[index];

      if (item) {
        item.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest",
        });
      }
    },

    slideLeft() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.slideToIndex(this.currentIndex);
      }
    },
    slideRight() {
      const maxIndex = this.packages.length - 1;
      if (this.currentIndex < maxIndex) {
        this.currentIndex++;
        this.slideToIndex(this.currentIndex);
      }
    },

    onTouchStart(e) {
      this.touchStartX = e.touches[0].clientX;
    },

    onTouchEnd(e) {
      this.touchEndX = e.changedTouches[0].clientX;
      this.handleSwipe();
    },

    handleSwipe() {
      const deltaX = this.touchEndX - this.touchStartX;

      if (Math.abs(deltaX) > 50) {
        if (deltaX > 0) {
          // Swipe right (show previous slide)
          this.slideLeft();
        } else {
          // Swipe left (show next slide)
          this.slideRight();
        }
      }
    },

    smoothScroll(element, to) {
      element.scrollTo({
        left: to,
        behavior: "smooth",
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.slideToIndex(this.currentIndex);
    });
  },
};
</script>

<style scoped lang="scss">
.best-value-box {
  position: fixed;
  left: 50%;
  bottom: 20px;
  transform: translate(-50%, 0);
  max-width: calc(100% - 20px);
  width: 400px;
  padding: 10px 15px;
  z-index: 99999;
  background-color: $color-credits-type4;
  justify-content: space-between;
  border-radius: 20px;

  p {
    font-size: 12px;
    font-weight: 700;
    margin-bottom: 5px;
    color: $color-best-value;
  }

  span {
    font-weight: 600;
    font-size: 16px;
    color: #ffffff;
  }
}

.price {
  text-align: center;
  max-width: 1080px;
  margin: 0 auto 30px;
}

.price__boxes {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-top: 30px;
  gap: 20px;
}

.price__boxes-wrapper {
  position: relative;
}

.price__item-row {
  position: relative;

  .button--primary {
    width: 100%;
    font-size: 14px;
    padding: 0 10px;
    background-color: $color-credits-type6;
    color: $color-type19;
    border: 1px solid $color-type19;
  }
}

.price__item {
  border-radius: 10px;
  background-color: $color-type1;
  position: relative;
  max-width: 500px;
  transition: all 0.3s ease-in-out;
  border: 1px solid $color-credits-border;
  padding: 24px 20px 24px;

  .heading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 40px;
    line-height: 38px;
    font-size: 20px;

    .best-value {
      margin-top: -17px;

      path {
        fill: $color-type19;
      }
    }
  }

  .unlock-chats {
    text-align: left;
    font-size: 21px;
  }

  .credits-euro {
    text-align: left;
  }

  h3 {
    text-align: left;
  }

  h4 {
    text-align: left;
    margin-bottom: 10px;
  }

  .heading {
    font-size: 14px;
    line-height: 38px;
    letter-spacing: 0px;
    margin-bottom: 10px;
    text-transform: uppercase;

    @media (min-width: 992px) {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      font-size: 20px;

      .best-value {
        margin-top: -17px;
      }
    }

    @media (max-width: 991px) {
      margin-bottom: 10px !important;
      align-items: flex-start;
      margin-top: 0;

      .best-value {
        margin-right: 10px;
      }
    }
  }

  &.is-active {
    background-color: $color-credits-type4;
    border-color: $color-credits-type1;
    transform: scale(1.1);

    h2 {
      color: $color-best-value;
    }

    h3 {
      color: $color-type1;
    }

    .unlock-chats {
      color: $color-credits-type1;
    }

    .total {
      color: $color-type1;
    }

    p,
    h4 {
      color: $color-credits-type3;
    }

    .price-box {
      color: $color-best-value;
    }

    .divider {
      background-color: rgba(255, 255, 255, 0.08);
    }
    .free-chat {
      .clr-black {
        color: #fff !important;
      }
    }

    .save-box {
      top: 0;
      right: 50%;
      transform: translate(50%, -50%);
      padding: 10px 15px;
      font-weight: 700;
      color: #fff;
      white-space: nowrap;
    }
    .button--primary {
      background-color: $color-type19;
      color: #fff;
    }

    .euro-credit {
      color: $color-best-value;
    }

    @media (max-width: 991px) {
      transform: scale(1);
    }
  }

  .unlock-chats {
    color: $color-credits-type1;
    margin-bottom: 16px;
    font-size: 21px;
  }

  h2 {
    font-size: 17px;
    line-height: 1.3;
    transition: all 0.3s ease-in-out;
    margin-bottom: 10px;
    color: $color-credits-type3;
  }

  h3 {
    font-size: 27px;
    font-weight: 600;
    color: $color-credits-type5;
  }

  .total {
    color: $color-credits-type5;
  }

  .euro-credit {
    font-size: 14px;
    margin-bottom: 20px;
    font-weight: 600;
  }

  p,
  h4 {
    color: $color-credits-type3;
  }

  .price-box {
    margin-bottom: 16px;
    color: $color-credits-type3;
    font-size: 12px;
    font-weight: 600;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    letter-spacing: -0.4px;
    text-align: left;
  }

  p {
    font-size: 18px;
    line-height: 1;
    transition: all 0.3s ease-in-out;
    margin-bottom: 5px;
    color: $color-credits-type3;
  }

  .divider {
    width: 100%;
    margin: 0 auto;
    background-color: #dedede;
    height: 1px;
    margin-bottom: 10px;
  }

  h3 {
    margin-bottom: 4px;
    font-size: 24px;
    font-weight: 700;
    line-height: 1.2;
    transition: all 0.3s ease-in-out;
    letter-spacing: -0.9px;
  }

  h4 {
    color: $color-type9;
    font-size: 20px;
    line-height: 1.6;
    transition: all 0.3s ease-in-out;
    font-weight: 700;
  }

  .free-chat {
    font-size: 12px;
    text-align: left;
    margin-bottom: 10px;
  }

  .save-box {
    background-color: $color-type19;
    color: $color-type1;
    text-align: left;
    border-radius: 15px;
    padding: 5px 10px;
    font-size: 14px;
    margin-bottom: 10px;
    display: inline-flex;
    position: absolute;
    right: 10px;
    top: 12px;
  }
}

.price__item--modal {
  padding: 12px 15px !important;

  h3 {
    margin-bottom: 0;
    display: flex;
    align-items: center;

    svg {
      margin-right: 5px;
    }
  }

  h4 {
    font-size: 14px;

    .line {
      position: relative;
      margin-left: 5px;

      &:before {
        width: 110%;
        height: 1px;
        background-color: #ff0000;
        content: "";
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%) rotate(-9deg);
      }
    }
  }

  &.is-active {
    h4 {
      color: #959595;
    }
  }

  @media (max-width: 991px) {
    h3 {
      font-size: 18px;

      .best-value {
        transform: translate(0, 0);
      }
    }
  }
}

@media (max-width: 991px) {
  .price {
    margin-bottom: 0;
    padding: 0 20px;
  }

  .price > p {
    font-size: 16px;
  }

  .price__item {
    padding: 20px 20px !important;
    margin: 10px auto;
    width: 100%;
  }

  .price__boxes {
    display: block;
    margin-top: 20px;
  }

  // .price__boxes-wrapper {

  //     &:before {
  //         position: absolute;
  //         right: 30px;
  //         top: 0;
  //         width: 50px;
  //         height: 100%;
  //         content:"";
  //         background: transparent linear-gradient(90deg, rgba(14, 20, 25, 0) 0%, #f5f5f5 100%) 0% 0% no-repeat padding-box;
  //         z-index: 1;
  //         pointer-events: none;
  //     }

  //     &:after {
  //         position: absolute;
  //         left: 30px;
  //         top: 0;
  //         width: 50px;
  //         height: 100%;
  //         content:"";
  //         background: transparent linear-gradient(90deg, rgba(14, 20, 25, 0) 0%, #f5f5f5 100%) 0% 0% no-repeat padding-box;
  //         z-index: 1;
  //         transform: rotate(180deg);
  //         pointer-events: none;
  //     }
  // }

  .price__item {
    padding: 60px 20px 40px;
    width: 300px;
    position: relative;
    max-width: 100%;
    min-width: 300px;
    scroll-snap-align: center;
    flex-shrink: 0;

    &:first-child {
      margin-left: calc(50vw - 150px); // 150px = min-width / 2
    }

    &:last-child {
      margin-right: calc(50vw - 150px);
    }
    margin-right: 10px;

    h4 {
      margin-bottom: 10px;
    }
  }

  .price__boxes {
    display: flex;
    align-items: center;
    gap: 0;
    overflow-x: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    padding: 20px 10px;
    scroll-snap-type: x mandatory;
    margin: 0 auto;
    width: 100%;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .scroll-trigger {
    position: absolute;
    top: 50%;
    transform: translate(10px, calc(-50% - 10px));
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: #21252d;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 3;
  }

  .scroll-left {
    left: 0;
    transform: translate(-10px, calc(-50% - 10px));

    svg {
      transform: rotate(180deg);
    }
  }

  .scroll-right {
    right: 0;
  }

  .slider-dots {
    display: flex;
    justify-content: center;
    margin-top: 10px;
    gap: 8px;
  }

  .dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #c7c7c7;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .dot.active {
    background-color: $color-credits-type1; // ili tvoja primarna boja
  }

  .price__item-row {
    .heading {
      margin-bottom: 10px;
      line-height: 1;
      margin-top: 0;
    }
  }

  // .price__item-row {
  //     display: flex;
  //     justify-content: space-between;
  //     align-items: center;

  //     &:first-child {
  //         h2 {
  //             font-size: 14px;
  //             margin-bottom: 0;
  //         }
  //     }

  //     &:nth-child(2) {
  //         flex-direction: row-reverse;

  //         p {
  //             font-size: 14px;
  //             margin-bottom: 10px;
  //         }

  //         h3 {
  //             font-size: 20px;
  //         }
  //     }

  //     &:last-child {

  //         h4 {
  //             margin-bottom: 20px;
  //             font-size: 14px;
  //             line-height: 1.2;
  //         }
  //     }

  //     .divider {
  //         display: none;
  //     }

  //     .button--primary {
  //         width: auto;
  //     }

  //     .price-box {
  //         line-height: 1;
  //         font-size: 22px;
  //         align-items: center;
  //         margin-bottom: 0;

  //         br {
  //             display: none;
  //         }
  //     }
  // }

  @media (max-width: 768px) {
    .slider-dots {
      margin-top: 0;
    }
  }
}

@media (max-width: 480px) {
  .price__item {
    .best-value {
      transform: translate(0, -10px);
    }

    .price-box {
      font-size: 12px;
    }

    .button--primary {
      font-size: 14px !important;
      height: 30px;
      padding: 0 10px;
    }

    .unlock-chats,
    .total {
      // font-size: 16px;
    }
  }
}
</style>
